











































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { getHours, padZero } from '@/utlitities/helper';
import { UserStore } from '@/store/user-module';
import StTimePickerPopover from '@/components/basic/StTimePickerPopover.vue';
//@ts-ignore
import VueBottomSheet from '@webzlodimir/vue-bottom-sheet';

@Component({
  components: { StTimePickerPopover },
})
export default class StTimePicker extends Vue {
  @Prop() inputClass!: string;
  @Prop() value!: string;
  @Prop() focus!: boolean;
  @Prop() disabled!: boolean;

  popoverOpen = false;

  tempHourPart: string = '';
  tempMinutePart: string = '';

  hoursArray: Array<string> = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
  minutesArray5: Array<string> = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
  minutesArray10: Array<string> = ['00', '10', '20', '30', '40', '50'];
  minutesArray15: Array<string> = ['00', '15', '30', '45'];
  minutesArray30: Array<string> = ['00', '30'];

  get userSettings() {
    return UserStore.userSettings;
  }

  get minutes(): Array<string> {
    switch (this.userSettings.timeRoundingInterval) {
      case 5:
        return this.minutesArray5;
      case 10:
        return this.minutesArray10;
      case 15:
        return this.minutesArray15;
      case 30:
        return this.minutesArray30;
      default:
        return this.minutesArray5;
    }
  }

  get hours() {
    return this.hoursArray;
  }

  get tempHourMinuteString() {
    return this.tempHourPart + ':' + this.tempMinutePart;
  }

  get hourPart() {
    if (!this.value) {
      return '';
    }
    return this.value.substr(0, 2);
  }

  set hourPart(val: string) {
    if (!this.minutePart) {
      this.tempMinutePart = this.minutes[0];
    }

    this.tempHourPart = val;

    this.input(this.tempHourMinuteString);
  }

  get minutePart() {
    if (!this.value) {
      return '';
    }
    return this.value.substr(3, 2);
  }

  set minutePart(val: string) {
    if (!this.hourPart) {
      this.tempHourPart = this.hours[0];
    }

    this.tempMinutePart = val;

    this.input(this.tempHourMinuteString);
  }

  @Watch('value')
  valueChanged() {
    this.tempMinutePart = this.minutePart;
    this.tempHourPart = this.hourPart;
  }

  mounted() {
    this.tempMinutePart = this.minutePart;
    this.tempHourPart = this.hourPart;
  }

  minuteChanged(minute: string) {
    this.minutePart = minute;
    if(this.userSettings.timeRoundingInterval>1){
      this.popoverOpen = false;
    }
  }

  hourChanged(hour: string) {
    this.hourPart = hour;
  }

  parseHourPart(strVal: string) {
    let intVal = parseInt(strVal, 10);

    if (!intVal) {
      this.hourPart = '00';
      return;
    }

    if (intVal > 23) {
      intVal = 0;
    }

    if (intVal < 0) {
      intVal = 0;
    }

    this.hourPart = padZero(intVal);
  }

  parseMinutePart(strVal: string) {
    let intVal = parseInt(strVal);

    if (!intVal) {
      this.minutePart = '00';
      return;
    }

    if (intVal > 59) {
      intVal = 59;
    }

    if (intVal < 0) {
      intVal = 0;
    }

    this.minutePart = padZero(intVal);
  }

  @Emit('input')
  input(val: string) {
    return val;
  }

  change(evt: any) {
    let timeString = evt.target.value;

    let hourPart = '0';
    let minutePart = '0';
    let durationMinutes = 0;

    if (timeString.length == 4 || timeString.length == 3) {
      if (parseInt(timeString) > 100) {
        if (timeString.length == 3) {
          timeString = '0' + timeString;
        }

        timeString = timeString.slice(0, 2) + ':' + timeString.slice(2);
      }
    }

    if (timeString.indexOf(':') > -1) {
      hourPart = timeString.split(':')[0];
      minutePart = timeString.split(':')[1];

      durationMinutes = Math.abs(parseInt(hourPart)) * 60 + parseInt(minutePart);
    } else {
      let time = parseFloat(timeString.replace(',', '.'));

      durationMinutes = Math.floor(time) * 60 + Math.round((time % 1) * 60);
    }

    let parsedTimeString = getHours(durationMinutes);

    this.parseHourPart(parsedTimeString.substr(0, 2));
    this.parseMinutePart(parsedTimeString.substr(3, 2));
  }
}
